import { render } from "./CreateTicketForm.vue?vue&type=template&id=4dc07bd0&ts=true"
import script from "./CreateTicketForm.vue?vue&type=script&lang=ts"
export * from "./CreateTicketForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__